import React from 'react';
import { Button } from '@brighterion/br-ui';
import { useTranslation } from 'react-i18next';
import { handleOnClickEvent, handleKeyEvent } from 'Utils';
import { RoleService } from 'Services';
import { shouldShowTenantGroups } from 'Selectors';
import AddTenantGroupModal from '../AddTenantGroupModal';

import styles from './Header.css';

type HeaderProps = {
    toggleAddTentantGroupButton: boolean;
};

const Header = ({ toggleAddTentantGroupButton }: HeaderProps) => {
    const { t } = useTranslation();
    const [toggleModal, setToggleModal] = React.useState(false);

    const addTenantGroup = () => {
        setToggleModal(true);
    };

    return (
        <div className={styles.globalRulesHeader}>
            <div className={styles.leftContainer}>
                <div data-testid='manage-tenants-page-title' className={styles.titleText}>
                    {t('Tenants')}
                </div>
            </div>
            {RoleService.hasTenantGroupWriteAccess && toggleAddTentantGroupButton && shouldShowTenantGroups() && (
                <>
                    <div className={styles.rightContainer}>
                        <span className={styles.addTenantGroupBtn}>
                            <Button
                                variant='secondary'
                                size='small'
                                onClick={handleOnClickEvent(addTenantGroup)}
                                onKeyDown={handleKeyEvent(addTenantGroup)}
                            >
                                {t('Add Tenant Group')}
                            </Button>
                        </span>
                    </div>
                    <AddTenantGroupModal isOpen={toggleModal} closeModal={() => setToggleModal(false)} />
                </>
            )}
        </div>
    );
};

export default Header;
